export default __webpack_public_path__ + "static/media/1943.ffb4fdef.png";